<template>
  <div class="project-load-skeleton no-point">
    <b-tabs pills>
      <b-tab>
        <template v-if="!reportsSkeleton" slot="title">
          <i class="i-Pen-4  ul-tab__icon" />
        </template>
        <b-card-text class="shine">
          <div class="master-row shine">
            <div class="button"></div>
            <div class="button"></div>
          </div>
          <div v-for="item in 2" :key="item" class=" section">
            <b-row>
              <b-col md="6">
                <i class="nav-icon i-Add"></i>
              </b-col>
              <b-col md="6" class="shine">
                <i class="nav-icon i-Remove f-r"></i>
                <i class="nav-icon i-Arrow-Up-in-Circle f-r"></i>
              </b-col>
            </b-row>
            <div class="task-shell task-shell-shine"></div>
            <div class="task-shell task-shell-shine"></div>
            <div class="task-shell-total task-shell-shine">
              <b-row>
                <b-col md="3">
                  <div class="progress-shell"></div>
                </b-col>
              </b-row>
            </div>
          </div>
        </b-card-text>
      </b-tab>
      <b-tab v-if="!reportsSkeleton">
        <template slot="title">
          <i class="i-Calendar-4  ul-tab__icon" />
        </template>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
export default {
  props: {
    reportsSkeleton: {
      type: Boolean,
      default: false
    }
  }
}
</script>
<style scoped>
.task-shell,
.task-shell-total {
  height: 45px;
  background-color: #f3f3f3;
  border-radius: 0.25rem;
  margin-bottom: 5px;
}
.task-shell-total {
  background-color: #dedede;
}
.progress-shell {
  height: 10px;
  background-color: #eee;
  border-radius: 10px;
  margin-top: 16px;
  margin-left: 15px;
}
.section {
  margin-bottom: 20px;
}
.project-load-skeleton .nav-link {
  background-color: #f3f3f3 !important;
  color: #f3f3f3 !important;
}

.project-load-skeleton .nav-item {
  margin-right: 10px;
}

.project-load-skeleton .nav-icon {
  font-size: 1.01625rem;
  background-color: #f3f3f3;
  color: #f3f3f3;
  border-radius: 50%;
}
.master-row {
  border-radius: 4px;
  margin-bottom: 5px;
}
.button {
  height: 23px;
  width: 131px;
  background-color: #f3f3f3;
  border-radius: 0.25rem;
  display: inline-block;
}
</style>
